import React from 'react';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AssignmentIcon from '@material-ui/icons/Assignment';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
/* import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faGavel } from '@fortawesome/free-solid-svg-icons' */
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import DescriptionIcon from '@material-ui/icons/Description';
import BeenhereIcon from '@material-ui/icons/Beenhere';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import SettingsIcon from '@material-ui/icons/Settings';
import Collapse from '@material-ui/core/Collapse';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import HomeWorkIcon from '@material-ui/icons/HomeWork';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));


export const AdministradorListItems = (
  <React.Fragment >
    <Divider />
    {/* <ListItem button to="/admin" component={Link}>
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Principal" />
    </ListItem> */}
    <ListItem button to="/admin/precalificaciones" component={Link}>
      <ListItemIcon>
        <DescriptionIcon />
      </ListItemIcon>
      <ListItemText primary="Precalificaciones" />
    </ListItem>
    <ListItem button to="/admin/precalificaciones-aprobadas" component={Link}>
      <ListItemIcon>
        <BeenhereIcon />
      </ListItemIcon>
      <ListItemText primary="Aprobadas" />
    </ListItem>
    <ListItem button to="/admin/precalificaciones-rechazadas" component={Link}>
      <ListItemIcon>
        <NotInterestedIcon />
      </ListItemIcon>
      <ListItemText primary="Rechazadas" />
    </ListItem>
    <Divider />
    {/* <ListItem button >
        <ListItemIcon>
          <InboxIcon />
        </ListItemIcon>
        <ListItemText primary="Inbox" />
         <ExpandLess />
      </ListItem>
      <Collapse in={true} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button >
            <ListItemIcon>
              <StarBorder />
            </ListItemIcon>
            <ListItemText primary="Starred" />
          </ListItem>
        </List>
      </Collapse> */}

    <ListItem button to="/admin/asesores" component={Link}>
      <ListItemIcon>
        <BusinessCenterIcon />
      </ListItemIcon>
      <ListItemText primary="Asesores" />
    </ListItem>
    
    <Divider />
    <ListItem button to="/admin/sectores" component={Link}>
      <ListItemIcon>
        <HomeWorkIcon />
      </ListItemIcon>
      <ListItemText primary="Sectores" />
    </ListItem>
    <ListItem button to="/admin/contacto" component={Link}>
      <ListItemIcon>
        <InboxIcon />
      </ListItemIcon>
      <ListItemText primary="Contactos" />
    </ListItem>
    <ListItem button to="/admin/parametros" component={Link}>
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText primary="Parametros" />
    </ListItem>
   {/*  <ListItem button to="/admin/clientes" component={Link}>
      <ListItemIcon>
        <PeopleAltIcon />
      </ListItemIcon>
      <ListItemText primary="Clientes" />
    </ListItem>
    <ListItem button to="/admin/aseguradoras" component={Link}>
      <ListItemIcon>
        <VerifiedUserIcon />
      </ListItemIcon>
      <ListItemText primary="Aseguradoras" />
    </ListItem>
    <ListItem button to="/admin/cotizaciones" component={Link}>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Cotizaciones" />
    </ListItem>
    <Divider inset="true" />
    <ListItem button to="/admin/nueva-cotizacion" component={Link}>
      <ListItemIcon>
        <LibraryAddIcon />
      </ListItemIcon>
      <ListItemText primary="Nueva cotización" />
    </ListItem> */}

  </React.Fragment>
);

export const ColaboradorListItems = (
  <React.Fragment>
    <Divider />
    <ListItem button to="/admin/precalificaciones" component={Link}>
      <ListItemIcon>
        <DescriptionIcon />
      </ListItemIcon>
      <ListItemText primary="Precalificaciones" />
    </ListItem>
    <ListItem button to="/admin/precalificaciones-aprobadas" component={Link}>
      <ListItemIcon>
        <BeenhereIcon />
      </ListItemIcon>
      <ListItemText primary="Aprobadas" />
    </ListItem>
    <ListItem button to="/admin/precalificaciones-rechazadas" component={Link}>
      <ListItemIcon>
        <NotInterestedIcon />
      </ListItemIcon>
      <ListItemText primary="Rechazadas" />
    </ListItem>
    <ListItem button to="/admin/contacto" component={Link}>
      <ListItemIcon>
        <InboxIcon />
      </ListItemIcon>
      <ListItemText primary="Contactos" />
    </ListItem>
    <Divider />
  </React.Fragment>
);